export default "__VITE_ASSET__Dgy3DhG8__"